import { useRef, useState, useEffect } from 'react'
import { Dialog } from '@headlessui/react'
import { DialogView } from "./DialogView";
import { SearchInput } from "./SearchInput";

export const UnitCodeDialog = ({
    open,
    setOpen,
    title = 'Escaneie o unit_code',
    onSubmit,
    onCancel,
    cancelLabel = 'Cancelar',
    allowedCodes = [],
    alreadyScanned = [],
    duplicateMessage = 'unit_code já escaneado',
    notInOrderMessage = 'unit_code não pertence ao pedido',
}) => {
    const inputRef = useRef();
    const [lastInputError, setLastInputError] = useState(null);
    const [currentValue, setCurrentValue] = useState('')

    const validate = (newCode) => {
        setCurrentValue(newCode)
        if (!newCode.length) return;

        if (alreadyScanned.includes(newCode)) {
            setLastInputError(`${duplicateMessage}: ${newCode}`)
            setCurrentValue('')
            inputRef.current?.resetInput()
            return
        }

        if (!allowedCodes.includes(newCode)) {
            setLastInputError(`${notInOrderMessage}: ${newCode}`)
            setCurrentValue('')
            inputRef.current?.resetInput()
            return
        }

        onSubmit(newCode)
        setLastInputError(null)
        setCurrentValue('')
        inputRef.current?.resetInput()
    }

    useEffect(() => {
        if (!open) {
            setLastInputError(null)
            setCurrentValue('')
            inputRef.current?.resetInput()
        }
    }, [open])

    return (
        <DialogView setOpen={setOpen} open={open} className="w-auto">
            <div>
                <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                        {title}
                    </Dialog.Title>
                </div>
            </div>
            <div className="mt-5 sm:mt-6">
                <SearchInput
                    placeholder="unit_code"
                    onChange={(value) => validate(value)}
                    numericOnly={false}
                    hideIcons={true}
                    debounce={250}
                    ref={inputRef}
                    value={currentValue}
                />
                {lastInputError && (
                    <p className="mt-1 text-sm text-red-600 text-center">{lastInputError}</p>
                )}
            </div>
            <div className="mt-5 sm:mt-6">
                <button
                    type="button"
                    className="mt-5 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    onClick={onCancel}
                >
                    {cancelLabel}
                </button>
            </div>
        </DialogView>
    )
}
